import { put, takeLatest, throttle } from 'redux-saga/effects';

import HospitalAPI from 'lib/api/HospitalAPI';
import createRequestSaga from 'store/helpers/createRequestSaga';
import { openSnackbar } from 'features/snackbar';
import {
  GET_NOT_PAID_PAYMENT_LIST,
  GET_PAYMENT_LIST,
  NOTIFY_PAYMENT,
  PREPARE_PAYMENT,
} from '.';

const getNotPaidPaymentListSaga = createRequestSaga(
  GET_NOT_PAID_PAYMENT_LIST,
  HospitalAPI.getPaymentList,
);
const getPaymentListSaga = createRequestSaga(
  GET_PAYMENT_LIST,
  HospitalAPI.getPaymentList,
);
const notifyPaymentSaga = createRequestSaga(
  NOTIFY_PAYMENT,
  HospitalAPI.notifyPayment,
  function* () {
    yield put(openSnackbar('결제요청 알림을 전송하였습니다'));
  },
);
const preparePaymentSaga = createRequestSaga(
  PREPARE_PAYMENT,
  HospitalAPI.preparePayment,
  function* () {
    yield put(openSnackbar('결제요청 메시지가 전송되었습니다'));
  },
);

export default function* paymentsSaga() {
  yield throttle(1000, GET_NOT_PAID_PAYMENT_LIST, getNotPaidPaymentListSaga);
  yield throttle(1000, GET_PAYMENT_LIST, getPaymentListSaga);
  yield takeLatest(NOTIFY_PAYMENT, notifyPaymentSaga);
  yield takeLatest(PREPARE_PAYMENT, preparePaymentSaga);
}
